// Custo Mão de Obra: cadastro completo de colaboradores com projeção de custo mensal
// (visão executiva, expõe salário individual — mesmo público de Faturamento Bruto).
// Espelha backend/config.py ROLES_MAO_DE_OBRA — mantenha os dois em sincronia.
export const ROLES_MAO_DE_OBRA = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];

export const NIVEIS_CARGO = [
  { value: "colaborador", label: "Colaborador" },
  { value: "lider", label: "Líder" },
];

export const MODELOS_TRABALHO = [
  { value: "remoto", label: "Remoto" },
  { value: "hibrido", label: "Híbrido" },
  { value: "presencial", label: "Presencial" },
];

export const REGIMES_MAO_DE_OBRA = [
  { value: "CLT", label: "CLT" },
  { value: "PJ", label: "PJ" },
  { value: "Estagio", label: "Estágio" },
];

export const AGRUPAMENTOS = Array.from({ length: 15 }, (_, i) => i); // 0–14

export const ENQUADRAMENTOS = Array.from({ length: 9 }, (_, i) => 0.8 + i * 0.05); // 80%–120%, passo 5%

export const MESES_MAO_DE_OBRA = [
  { value: 1, label: "Janeiro" }, { value: 2, label: "Fevereiro" }, { value: 3, label: "Março" },
  { value: 4, label: "Abril" }, { value: 5, label: "Maio" }, { value: 6, label: "Junho" },
  { value: 7, label: "Julho" }, { value: 8, label: "Agosto" }, { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" }, { value: 11, label: "Novembro" }, { value: 12, label: "Dezembro" },
];

export const VISOES_MAO_DE_OBRA = [
  { id: "salario", label: "Salário Bruto", campoMensal: "meses_salario", campoTotal: "total_salario" },
  { id: "encargos", label: "Encargos", campoMensal: "meses_encargos", campoTotal: "total_encargos" },
  { id: "beneficios", label: "Benefícios", campoMensal: "meses_beneficios", campoTotal: "total_beneficios" },
  { id: "total", label: "Custo Total", campoMensal: "meses_custo_total", campoTotal: "total_custo_total" },
];
